import { render, staticRenderFns } from "./NotificationsResponseCountPieChart.vue?vue&type=template&id=49b71ff8&scoped=true&"
import script from "./NotificationsResponseCountPieChart.vue?vue&type=script&lang=js&"
export * from "./NotificationsResponseCountPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b71ff8",
  null
  
)

export default component.exports